import { render, staticRenderFns } from "./GameSettingsView.vue?vue&type=template&id=b9b06d8c&scoped=true"
import script from "./GameSettingsView.vue?vue&type=script&lang=js"
export * from "./GameSettingsView.vue?vue&type=script&lang=js"
import style0 from "./GameSettingsView.vue?vue&type=style&index=0&id=b9b06d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b06d8c",
  null
  
)

export default component.exports